import type {Values} from '@wix/devzai-utils-common';
import type {DoppeBusinessEntityReference} from '../types/doppe-business-entity';

export const DoppeListDataItemsSource = {
    Static: 'Static',
    Dynamic: 'Dynamic',
} as const;

export type DoppeListDataItemsSource = Values<typeof DoppeListDataItemsSource>;

export type DoppeListDataItemsSourceInfo =
    | { type: typeof DoppeListDataItemsSource.Static }
    | { type: typeof DoppeListDataItemsSource.Dynamic; source: DoppeBusinessEntityReference };
